import { Navigate, Outlet } from 'react-router-dom';

import { useAuth } from '../hooks/useAuth';
import CommandPalette from './CommandPalette';
import { CommandPaletteProvider } from '../hooks/useCommandPalette';
import Sidebar from './Sidebar';
import ClinicAgentPanel from './agent/ClinicAgentPanel';
import AgentPanel from './agent/conversations/AgentPanel';
import PatientNotesPanel from './notes/PatientNotesPanel';
import { PatientContextSheetProvider } from './agent-context/PatientContextSheet';

const AppShell = () => {
  const { access } = useAuth();

  if (!access) {
    return <Navigate to="/login" />;
  }

  // A flex row rather than the old fixed sidebar plus a hard-coded 240px
  // margin on <main>: the sidebar can now change width (docked, railed, or
  // gone into a drawer) without any other component knowing about it.
  return (
    <CommandPaletteProvider>
      <PatientContextSheetProvider>
      <div className="flex min-h-screen bg-app-background">
        {/* First thing in the tab order: a keyboard user should not have to walk
         *  the whole nav to reach the page. Visible only once focused. */}
        <a
          href="#contenido"
          className="sr-only focus:not-sr-only focus:absolute focus:top-3 focus:left-3 focus:z-100 focus:rounded-control focus:bg-card focus:px-4 focus:py-2 focus:text-sm focus:font-semibold focus:shadow-overlay focus:outline-2 focus:outline-ring"
        >
          Saltar al contenido
        </a>

        <Sidebar />
        <main id="contenido" className="min-w-0 flex-1">
          <Outlet />
        </main>
        {/* Sissi AI with conversations: one panel on the right of the page. */}
        <AgentPanel />
        <ClinicAgentPanel />
        <PatientNotesPanel />

        {/* ⌘K from anywhere, and the header's search field. */}
        <CommandPalette />
      </div>
      </PatientContextSheetProvider>
    </CommandPaletteProvider>
  );
};

export default AppShell;
